import smsDashboard from './smsDashboard.json';
import actionTimesQuotas from './action-times-quotas.json';
import activityStatuses from './activity-statuses.json';
import assignees from './assignees.json';
import labels from './labels.json';
import cohorts from './cohorts.json';
import loginStatuses from './login-statuses.json';
import languages from './languages.json';
import controls from './controls.json';
import tabs from './tabs.json';
import genders from './genders.json';
import races from './races.json';
import rangeTypes from './range-types.json';
import smsTypes from './sms-types.json';
import smsStatuses from './sms-statuses.json';
import maritalStatuses from './marital-statuses.json';
import workingStatuses from './working-statuses.json';
import titles from './titles.json';
import rpmStatuses from './rpm-statuses.json';
import ccmStatuses from './ccm-statuses.json';
import numberTypes from './number-types.json';
import contactMethods from './contact-methods.json';
import states from './states.json';
import stateAbbreviations from './state-abbreviations.json';
import timezones from './timezones.json';
import validation from './validation.json';
import dates from './dates.json';
import weekMealStatuses from './week-meal-statuses.json';
import confirm from './confirm.json';
import holdingStatuses from './holding-statuses.json';
import appointmentMethod from './appointment-method.json';
import messages from './messages.json';
import insuranceProviders from './insurance-providers.json';
import insuranceTypes from './insurance-types.json';
import readingTypes from './reading-types.json';
import deviceAlertStatus from './device-alert-status.json';
import doNotCallRestrictionType from './do-not-call-restriction-type.json';
import links from './links.json';
import pcctNotesGenerator from './pcct-notes-generator.json';
import units from './units.json';
import interactiveTimeDashboard from './interactive-time-dashboard.json';
import ccmAgentDashboard from './ccm-agent-dashboard.json';
import filters from './filters.json';
import errors from './errors.json';
import claimStatuses from './claim-statuses.json';
import clinicReferralTypes from './clinic-referral-types.json';
import providerServiceTypes from './provider-service-types.json';
import serviceDeliveryThresholds from './service-delivery-thresholds.json';
import clinicServiceDeliveryModels from './clinic-service-delivery-models.json';
import clinicRevenueChannels from './clinic-revenue-channels.json';
import clinicStatuses from './clinic-statuses.json';
import deviceAlertChangeStatus from './device-alert-change-status.json';
import ccmStatusReportDashboard from './ccm-status-report-dashboard.json';
import adminTools from './admin-tools.json';
import responseMessages from './response-messages.json';
import consumables from './consumables.json';
import historyLog from './history-log.json';
import salesForceIntegrations from './salesforce-integration.json';
import rpmAlertAssessment from './rpm-alert-assessment.json';
import clinicSalesForce from './clinic-sales-force.json';
import placeholders from './placeholders.json';
import newPatients from './new-patients.json';
import pcmConsentForm from './pcm-consent-form.json';
import ccmConsentForm from './ccm-consent-form.json';
import smsAutoReplySettings from './sms-autoreply-settings.json';
import clinics from './clinics.json';
import overviewDashboardSort from './overview-dashboard-sort.json';
import overviewDashboard from './overview-dashboard.json';
import callAttempt from './call-attempt.json';
import runbook from './runbook.json';
import apcmConsentForm from './apcm-consent-form.json';
import apcmTemplate from './apcm-template.json';
import apcmEligibility from './apcm-eligibility.json';
import digitalEngagement from './digital-engagement.json';
import patientSnapshot from './patient-snapshot.json';
import linkedCallReadings from './linked-call-readings.json';
import unsavedMessages from './unsaved-messages.json';
import actionTimesManagement from './action-time-management.json';
import actionTypes from './action-types.json';
import queueLimits from './queue-limits.json';
import connectPanel from './connect-panel.json';
import patientReportTooltips from './patient-report-tooltips.json';
import patientEngagementReport from './patient-engagement-report.json';

export const en = {
  translation: {
    adminTools,
    actionTimesQuotas,
    activityStatuses,
    assignees,
    smsDashboard,
    pcmConsentForm,
    ccmConsentForm,
    controls,
    placeholders,
    labels,
    cohorts,
    languages,
    tabs,
    genders,
    races,
    rangeTypes,
    smsTypes,
    smsStatuses,
    maritalStatuses,
    workingStatuses,
    titles,
    rpmStatuses,
    ccmStatuses,
    numberTypes,
    contactMethods,
    states,
    stateAbbreviations,
    holdingStatuses,
    timezones,
    validation,
    dates,
    weekMealStatuses,
    confirm,
    appointmentMethod,
    messages,
    insuranceProviders,
    insuranceTypes,
    readingTypes,
    deviceAlertStatus,
    doNotCallRestrictionType,
    pcctNotesGenerator,
    units,
    interactiveTimeDashboard,
    filters,
    claimStatuses,
    links,
    clinicReferralTypes,
    providerServiceTypes,
    serviceDeliveryThresholds,
    clinicServiceDeliveryModels,
    clinicRevenueChannels,
    clinicStatuses,
    deviceAlertChangeStatus,
    ccmAgentDashboard,
    ccmStatusReportDashboard,
    errors,
    responseMessages,
    consumables,
    historyLog,
    rpmAlertAssessment,
    loginStatuses,
    salesForceIntegrations,
    clinicSalesForce,
    newPatients,
    smsAutoReplySettings,
    unsavedMessages,
    clinics,
    overviewDashboardSort,
    overviewDashboard,
    callAttempt,
    runbook,
    patientSnapshot,
    digitalEngagement,
    apcmConsentForm,
    apcmTemplate,
    apcmEligibility,
    linkedCallReadings,
    actionTimesManagement,
    actionTypes,
    queueLimits,
    connectPanel,
    patientReportTooltips,
    patientEngagementReport,
  },
};
